import { Card, CardContent, Typography } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";

const readinessData = [
  { id: 0, value: 89, label: "false", color: "#1976d2" }, // blue
  { id: 1, value: 11, label: "true", color: "#d32f2f" }, // red
];

export default function StreamingReadinessWidget() {
  return (
    <Card sx={{ height: "100%", borderRadius: 3, width: "100%" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Streaming Readiness
        </Typography>

        <PieChart
          series={[
            {
              data: readinessData,
              highlightScope: { fade: "global", highlight: "item" },
              faded: { innerRadius: 30, additionalRadius: -10 },
            },
          ]}
          height={280}
        />
      </CardContent>
    </Card>
  );
}
